import { Button } from "@mui/material";
import Telegram from "../assets/Telegram.png";

export default function TelegramButton() {
  return (
    <Button
      component="a"
      role={undefined}
      variant="outlined"
      sx={{ fontSize: "large" }}
      tabIndex={-1}
      href="https://t.me/hashrate0"
      target="_blank"
      startIcon={
        <img src={Telegram} style={{ height: "2.5em" }} alt="Telegram logo" />
      }
    >
      Telegram
    </Button>
  );
}
